import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-video-viewer',
  templateUrl: './audio-video-viewer.component.html',
  styleUrls: ['./audio-video-viewer.component.css']
})
export class AudioVideoViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
